// KakaoAdFit.jsx
import React, { useEffect, useRef } from "react";

export default function KakaoAdFit({
  unit = "DAN-Uyyk4O8NizlZFmbh", // AdFit 광고 단위 ID
  width = 224,
  height = 224,
  className = "",
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // 초기화
    container.innerHTML = "";

    // <ins>
    const ins = document.createElement("ins");
    ins.className = "kakao_ad_area";
    ins.style.display = "none";
    ins.setAttribute("data-ad-unit", unit);
    ins.setAttribute("data-ad-width", String(width));
    ins.setAttribute("data-ad-height", String(height));
    container.appendChild(ins);

    // <script> (형제)
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "//t1.daumcdn.net/kas/static/ba.min.js";
    container.appendChild(s);

    return () => {
      container.innerHTML = "";
    };
  }, [unit, width, height]);

  return <div ref={containerRef} className={className} />;
}
